export default __webpack_public_path__ + "static/media/gwn48.d11e257d.webp";